<template>
  <div class="modal-overlay" @click="close">
    <div class="products-modal" @click.stop>
      <div class="modal-content" @click.stop>
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <h2>Select Role</h2>
        <p style="margin-top: 20px;">
          You have multiple roles. Please select the role you want to log in as:
        </p>
        <div v-if="normalizedRoles.length === 0" class="alert alert-danger error-message" role="alert">
          No roles available for this user.
        </div>
        <div v-else class="roles-list">
          <button
            v-for="role in normalizedRoles"
            :key="role"
            class="role-btn"
            @click="selectRole(role)"
          >
            {{ getReadableRole(role) }}
          </button>
        </div>
        <div>
          <button @click="close()" class="btn btn-secondary"
            style="margin-top: 15px; margin-bottom: 10px; border: 1px solid #5A5A5A;">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    roles: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    normalizedRoles() {
      // ensure unique, non-empty strings
      return [...new Set((this.roles || []).filter(r => typeof r === 'string' && r.trim() !== ''))];
    },
  },
  methods: {
    getReadableRole(role) {
      const roleMappings = {
        admin: 'Administrator',
        examiner: 'Examiner',
        practical_manager: 'Practical Element Manager',
        project_manager: 'Session Manager',
        instructor: 'Instructor',
        trainee: 'Trainee',
        assessor: 'Assessor',
      };
      return roleMappings[role] || role; // Default to original role if not found
    },
    selectRole(role) {
      this.$emit('role-selected', role); // Emit the selected role to the parent
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.products-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  max-width: 90vw;
  max-height: 97vh;
  min-width: min(500px, 75%);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.modal-content {
  border: white;
  padding: 15px;
  border: 1px solid #dddddd;
  border-radius: 3px;
}

h2 {
  text-align: center;
  margin-bottom: 10px;
  margin-left: 0px;
  font-size: 1.5rem;
}

.alert-danger {
  color: #ff0019;
  background-color: #f8d7da;
  border: 1px solid #e6b0b6;
}

.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 0rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}

.roles-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.role-btn {
  width: 300px;
  /* Increase the width to 200px for better visibility */
  background-color: rgb(51, 165, 165);
  color: white;
  padding: 10px 10px;
  margin: 10px 0;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  border-radius: 3px;
  border: 1px solid rgb(29, 83, 83);
}

.role-btn:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  /* More pronounced shadow on hover */
  transform: translateY(-2px);
  /* Slight lift effect on hover */
  background-color: rgb(30, 99, 99);
}
</style>